<template>
  <v-data-iterator
    :items="contracts.data"
    :page.sync="page"
    :items-per-page.sync="size"
    :server-items-length="contracts.meta.pagination.total"
    :footer-props="{ itemsPerPageOptions }"
  >
    <template v-slot:default="slot">
      <im-contract-card v-for="(contract, index) in slot.items"
        :contract="contract"
        :key="index"
        @edit="$emit('edit', contract)"
      />
    </template>
  </v-data-iterator>
</template>


<script>

  export default {

    components: {
      'im-contract-card': () => import('@/components/Contract/ContractCard')
    },

    props: {
      contracts: Object
    },

    data: () => ({
      page: 1,
      size: 10,
      itemsPerPageOptions: [10, 15, 30, 50]
    }),

    watch: {
      page: {
        handler () {
          this.$emit('list', {
            size: this.size,
            page: this.page
          })
        },
        immediate: false,
        deep: true
      },
      size: {
        handler () {
          this.$emit('list', {
            size: this.size,
            page: this.page})
        },
        immediate: false,
        deep: true
      },
    },
  }

</script>